import React from 'react';
import {View} from 'react-native';

import ListItem from '/component/base/ListItem';
import {LoadingBox} from '/component/base/LoadingBox';
import Text from '/component/base/Text';
import Gutter from '/component/layout/Gutter';
import {useTranslation} from '/provider/TranslationProvider';

import {styles} from './Loading.style';

export const Loading = () => {
  const {tt} = useTranslation('reportCardContent.allSearchCoaches');

  return (
    <View style={styles.base}>
      <View style={styles.header}>
        <Gutter>
          <Text variant="heading">
            {tt('title', 'All Organization Coaches')}
          </Text>
        </Gutter>
      </View>
      <Gutter>
        <ListItem
          style={{base: styles.listItem}}
          readonly={true}
          label={<Text>{tt('activationDate', 'Activation Date')}</Text>}
          suffix={<LoadingBox style={styles.loadingBoxActivationDate} />}
        />
      </Gutter>
      <Gutter>
        <ListItem
          style={{base: styles.listItem}}
          readonly={true}
          label={<Text>{tt('businessCoach', 'Business Coach')}</Text>}
          suffix={<LoadingBox style={styles.loadingBoxBusinessCoach} />}
        />
      </Gutter>
      <Gutter>
        <ListItem
          style={{base: styles.listItem}}
          readonly={true}
          label={
            <Text>{tt('highestRankAchieved', 'Highest Rank Achieved')}</Text>
          }
          suffix={<LoadingBox style={styles.loadingBoxHighestAchievedRank} />}
        />
      </Gutter>
      <Gutter>
        <ListItem
          style={{base: styles.listItem}}
          readonly={true}
          label={<Text>{tt('orderingEntities', 'Ordering Entities')}</Text>}
          suffix={<LoadingBox style={styles.loadingBoxOrderingEntities} />}
        />
      </Gutter>
      <Gutter>
        <ListItem
          style={{base: styles.listItem}}
          readonly={true}
          label={<Text>{tt('qualifyingPoints', 'Qualifying Points')}</Text>}
          suffix={<LoadingBox style={styles.loadingBoxQualifyingPoints} />}
        />
      </Gutter>
    </View>
  );
};
